import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b9e5411"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-wrapper" }
const _hoisted_2 = { class: "game-wrapper__headline-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game-wrapper__headline-side-container" }, null, -1))
const _hoisted_4 = { class: "game-wrapper__headline-side-container" }
const _hoisted_5 = { class: "game-wrapper__container" }
const _hoisted_6 = { class: "game-wrapper__button-container margin-horizontal--large" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Restart")
const _hoisted_9 = {
  key: 0,
  class: "game-wrapper__main-container"
}
const _hoisted_10 = {
  key: 1,
  class: "game-wrapper__game-info-container"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Start Game")
const _hoisted_12 = {
  key: 1,
  class: "game-wrapper__game-over-box"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Game Over", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Score: ")
const _hoisted_15 = {
  key: 2,
  class: "game-wrapper__pregame-countdown"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game-wrapper__down-draw" }, null, -1))
const _hoisted_17 = {
  key: 3,
  class: "game-wrapper__action-button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_game_button = _resolveComponent("game-button")!
  const _component_action_button = _resolveComponent("action-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", {
        class: _normalizeClass(["game-wrapper__headline", { 'game-wrapper__headline--long': _ctx.title.length > 13 }])
      }, _toDisplayString(_ctx.title), 3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["game-wrapper__help-button", { 'game-wrapper__help-button--small': _ctx.title.length > 13 }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
        }, " ? ", 2),
        (_ctx.isHelpModalOpen)
          ? (_openBlock(), _createBlock(_component_modal, {
              key: 0,
              headline: "Help",
              sections: _ctx.helpModalContent,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isHelpModalOpen = false))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.gameHelperComponent)))
              ]),
              _: 1
            }, 8, ["sections"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "top", {}, undefined, true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_game_button, {
          class: "game-wrapper__top-button",
          alternative: "B",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push('/')))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_game_button, {
          class: "game-wrapper__top-button",
          alternative: "R",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('restart')))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      (!_ctx.isGameOver && !_ctx.isPreCountdownRunning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isGameOver || _ctx.isPreCountdownRunning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.isFirstGame && !_ctx.isPreCountdownRunning)
              ? (_openBlock(), _createBlock(_component_game_button, {
                  key: 0,
                  class: "game-wrapper__start-button",
                  alternative: "S",
                  "is-borderless": true,
                  "is-large": true,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('restart')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
              : (!_ctx.isFirstGame && !_ctx.isPreCountdownRunning)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", null, [
                      _hoisted_14,
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.pointsClass)
                      }, _toDisplayString(_ctx.points), 3)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.preCountdown.value === 0 ? "" : _ctx.preCountdown.value), 1))
          ]))
        : _createCommentVNode("", true),
      _hoisted_16,
      (!_ctx.isPreCountdownRunning)
        ? _renderSlot(_ctx.$slots, "bottom", { key: 2 }, undefined, true)
        : _createCommentVNode("", true),
      (!_ctx.isPreCountdownRunning && !_ctx.isGameOver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionButtons, (button) => {
              return (_openBlock(), _createBlock(_component_action_button, {
                key: button.name,
                class: _normalizeClass(["game-wrapper__action-button", [
            button.isFullSize
              ? 'game-wrapper__action-button--full'
              : 'game-wrapper__action-button--default',
            button.hasExtraBorder ? 'border-left--dark' : '',
          ]]),
                "is-large": true,
                onClick: ($event: any) => (_ctx.$emit(button.clickEvent.event, button.clickEvent.value)),
                alternative: button.alternative,
                "is-borderless": true,
                "has-fly-out": button.hasFlyOut ? true : false,
                label: button.label,
                "action-counter": button.actionCounter
              }, null, 8, ["class", "onClick", "alternative", "has-fly-out", "label", "action-counter"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}